export const TOKEN_KEY = 'ci-token'
export const SIDEBAR_COLLAPSED_KEY = 'ci-sidebar-collapsed'
export const THEME_KEY = 'ci-theme'
export const MEDIA_KEY = 'ci-media'
